import baseAxios, {
  AxiosError,
  isAxiosError,
  type AxiosResponse,
  type AxiosRequestConfig as BaseAxiosRequestConfig,
  type InternalAxiosRequestConfig,
} from "axios";
import snakecaseKeys from "snakecase-keys";
import { csrfToken } from "@root/shared/utils/csrf";

declare module "axios" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface AxiosRequestConfig {
    caseConversion?: "snake" | "none";
  }
}

const axiosInstance = baseAxios.create();

axiosInstance.defaults.headers.common["X-CSRF-Token"] = csrfToken();

axiosInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const caseConversion = config.caseConversion ?? "snake";
  const shouldConvert = caseConversion !== "none";

  return {
    ...config,
    // NOTE: クエリパラメータ（GET、DELETEなど）
    params:
      shouldConvert && config.params ? snakecaseKeys(config.params, { deep: true }) : config.params,
    // NOTE: リクエストボディ（POST、PUT、PATCHなど）
    data:
      shouldConvert &&
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData) &&
      !(config.data instanceof URLSearchParams)
        ? snakecaseKeys(config.data, { deep: true })
        : config.data,
  };
});

export {
  axiosInstance as axios,
  isAxiosError,
  AxiosError,
  type AxiosResponse,
  type BaseAxiosRequestConfig as AxiosRequestConfig,
};
